import { Component, OnInit, inject, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  RouterModule,
} from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { SubHeaderComponent } from '../sub-header/sub-header.component';
import { HeaderComponent } from '../header/header.component';
import { ProductService } from '../../service/product.service';
import { BaseComponent } from '../../../base/components/base.component';
import { SecondaryRoles } from '../../interfaces/secondary-roles';
import { USER_KEY } from '../../service/storage.service';
import { User, UserType } from '../../models/user';
import { SidebarService } from '../../service/sidebar.service';
import { ClickableDirective } from '../../directives/clickable.directive';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatSidenavModule,
        RouterModule,
        SidebarComponent,
        SubHeaderComponent,
        HeaderComponent,
        ClickableDirective
    ]
})
export class LayoutComponent extends BaseComponent implements OnInit, AfterViewInit {
  private readonly cdr = inject(ChangeDetectorRef);
  closeSidebar() {
    this.sidebarOpen = false;
  }
  prodService = inject(ProductService);
  activatedRoute = inject(ActivatedRoute);

  isDashboard: boolean = false;
  isViewAsCustomer = false;
  user: User;
  userRole=UserType;
  userType = SecondaryRoles;
  sidebar(value: boolean) {
    this.sidebarOpen = false;
  }
  constructor() {
    super();
    this.user = this.storageService.getObject(USER_KEY);

    let url = this.router.url;
    this.isViewAsCustomer =
      url.includes('/customer/dashboard') &&
      this.user.user_type === UserType.SYSTEM_INTEGRATOR;
    
    let route = url.split('/');
    let curTab = route.at(-2);
    this.isDashboard = curTab === 'dashboard';
  }
  sidebarOpen = false;

  sidebarService = inject(SidebarService);

  ngOnInit(): void {
    this.sidebarService.sidebarToggle$.subscribe(() => {
      this.sidebarOpen = !this.sidebarOpen;
      this.cdr.markForCheck();
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        let route = event.url.split('/');
        let curTab = route.at(-2) ?? '';
        this.changeTab(curTab);
      }
      if (event instanceof NavigationEnd) {
        let route = event.urlAfterRedirects.split('/');
        let curTab = route.at(-2) ?? '';
        this.changeTab(curTab);
      }
    });
  }

  ngAfterViewInit(): void {
    if((globalThis as any).__karma__) return;
  }

  changeTab(curTab: string) {
    if (curTab === 'dashboard') {
      this.isDashboard = true;
    } else {
      this.isDashboard = false;
    }
    this.cdr.markForCheck();
  }
}
